import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';

import { SharedConstants, TextType } from '@app/eds';

export type labelRadioKeyValueType = {
  id: number;
  title: string;
  value?: string;
  isSelectionDisabled?: boolean;
  showTooltip?: boolean;
};

@Component({
  selector: 'app-label-radio',
  templateUrl: './label-radio.component.html',
  styleUrls: ['./label-radio.component.scss']
})
export class LabelRadioComponent {
  // Form control for the radio box
  dataControl = new FormControl(SharedConstants.EMPTY_STRING);

  // Data stores the value which is of LabelRadioKeyValueType.
  @Input() data: labelRadioKeyValueType[] = [];

  // RadioLabelFontType stores the font type.
  @Input() radioLabelFontType!: TextType;

  // RadioLabel stores the value of label.
  @Input() radioLabel!: string;

  // isCheckedData is used to store which data needs to be checked
  @Input() isCheckedData!: labelRadioKeyValueType;

  // This field tells whether the input component is reuired or not , should be pass while calling the component.
  @Input() isRequired = false;

  // If true then disable all the selection.
  @Input() isSelectionDisabled = false;

  // FormControl field for the radiobox
  @Input() set control(value: FormControl) {
    if (value !== this.dataControl) {
      this.dataControl = value;
    }
  }

  // The text that is to be displayed on the tooltip.
  @Input() tooltipTextKey!: string;

  // RadioSelectedHandler emits an event of which data selected.
  @Output() radioSelectedHandler: EventEmitter<labelRadioKeyValueType> =
    new EventEmitter<labelRadioKeyValueType>();

  /**
   * This method is used to check which radio option is selected.
   *
   * @param {labelRadioKeyValueType} holds the value selected
   */
  onRadioButtonSelected = (value: labelRadioKeyValueType) =>
    this.radioSelectedHandler.emit(value);

  /**
   * This method is used to check if data is checked
   *
   * @param {labelRadioKeyValueType} item
   * @returns {boolean}
   */
  getCheckedData = (item: labelRadioKeyValueType) =>
    this.isCheckedData?.id === item.id && this.isCheckedData?.title === item.title
      ? true
      : false;

  /**
   * This function is called to check if the radio option is disabled.
   *
   * @param {labelRadioKeyValueType} option
   * @returns {boolean} if the option is disabled, else false.
   */
  isOptionDisabled = (option: labelRadioKeyValueType) =>
    this.isSelectionDisabled || !!option.isSelectionDisabled;
}
